// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-inline-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 20px;
  align-items: end;
}

.skl-inline-actions {
  display: flex;
  gap: 12px;
}

@media (max-width: 991.98px) {
  .skl-inline-grid {
    grid-template-columns: 1fr;
  }
  .skl-inline-actions {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/users-sync/users-sync-config-skeleton/users-sync-config-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;EAEA;IACE,eAAA;EAAF;AACF","sourcesContent":[".skl-inline-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 20px;\n  align-items: end;\n}\n\n.skl-inline-actions {\n  display: flex;\n  gap: 12px;\n}\n\n@media (max-width: 991.98px) {\n  .skl-inline-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .skl-inline-actions {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
